module.exports = __webpack_public_path__ + "assets/img/kangenbei.5d640a4e.png";